<p-toast></p-toast>

<div class="col-12 complete-block">
    <!-- primary block starts -->
    <div class="card" reflow="true">
        <h5>{{'FARMERS_APPLICATION_CHANGES_REQUEST'| translate}}</h5>

        <div class="p-fluid p-formgrid grid mt-4">
            <!-- Application Number -->
            <!-- <div class="field col-12 md:col-4 grid">
                <label htmlFor="appId"><b>Select Application Id</b></label>
                <p-dropdown [options]="famerAppDetailsforDropDown" [(ngModel)]="selectedFarmerDeatils"
                    optionLabel="appIdToDisplay" (onChange)="onSelectAppId()" placeholder="Select an Application Id"
                    [style]="{'width':'20vw'}"></p-dropdown>
            </div> -->

            <!-- Change Request Type -->
            <div class="field col-12 md:col-4 mx-3">
                <label htmlFor="change-request-type"><b>{{'CHANGE_REQUEST_TYPE'| translate}}</b></label>
                <span class="p-float-label">
                    <p-multiSelect [options]="requestType" [(ngModel)]="selectedRequestType" optionLabel="reqType"
                        (onChange)="onSelectChangeRequestType()" placeholder="{{'SELECT_WHAT_YOU_WANT_TO_CHANGE'| translate}}">
                    </p-multiSelect>
                </span>
            </div>
        </div>
    </div>
    <!-- primary block end -->


    <!-- personal-details-starts -->
    <div class="personal-details-container" *ngIf="showPersonalDetailsCard">
        <div class="card personal-details" reflow="true">
            <h5>{{'FARMERS_DETAILS'| translate}}</h5>
            <form [formGroup]="farmersDetailsForm">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label htmlFor="farmerName">{{'FARMER_NAME'| translate}}</label>
                        <input formControlName="farmersName" pInputText id="farmerName" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.farmersName.errors }" />
                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.farmersName.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.farmersName.errors.required">{{'FARMER_NAME_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'FARMER_PHOTO'| translate}}</label>
                        <div class="flex">


                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPhotoFileUpload [customUpload]="true"
                                (uploadHandler)="onUpload($event, 'farmersPhotoPath', farmerPhotoFileUpload)"
                                name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="BROWSE" [auto]="true">
                            </p-fileUpload>
                            <p-image *ngIf="farmersFormControls.farmersPhotoPath.value"
                                [src]="farmersFormControls.farmersPhotoPath.value" alt="Image" width="60"
                                class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

                        </div>
                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.farmersPhotoPath.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.farmersPhotoPath.errors.required">{{'FARMERS_PHOTO_IS_REQUIRED'| translate}}
                            </div>
                        </div>

                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="gender">{{'GENDER'| translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="gender" value="M" id="IsSubsidyAvailabeNo"
                                        [(ngModel)]="genderType"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'MALE'| translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="gender" value="F" id="IsSubsidyAvailabeNo"
                                        [(ngModel)]="genderType"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'FEMALE'| translate}}</label>
                                </div>
                            </div>
                            <div class="field mr-0">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="gender" value="T" id="IsSubsidyAvailabeNo"
                                        [(ngModel)]="genderType"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'TRANSGENDER'| translate}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="fatherName">{{'FATHERS_NAME'| translate}}</label>
                        <input formControlName="fathersName" pInputText id="fatherName" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.fathersName.errors }" />

                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.fathersName.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.fathersName.errors.required">{{'FATHERS_NAME_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="motherName">{{'MOTHER_NAME'| translate}}</label>
                        <input formControlName="mothersName" pInputText id="motherName" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.mothersName.errors }" />

                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.mothersName.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.mothersName.errors.required">{{'MOTHERS_NAME_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'DATE_OF_BIRTH'| translate}}</label>
                        <p-calendar [maxDate]="todayDate" [showIcon]="true" [showButtonBar]="true" dateFormat="dd-mm-yy"
                            formControlName="dob"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.dob.errors }">
                        </p-calendar>
                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.dob.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.dob.errors.required">{{'DATE_OF_BIRTH_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="fatherName">{{'EMAIL_ID'| translate}}</label>
                        <input formControlName="emailId" pInputText id="fatherName" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.emailId.errors }" />

                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.emailId.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.emailId.errors.required">{{'EMAIL_ID_IS_REQUIRED'| translate}}</div>
                            <div *ngIf="farmersFormControls.emailId.errors.email">{{'EMAIL_IS_INVALID'| translate}}</div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="fatherName">{{'MOBILE'| translate}}</label>
                        <div>
                            <span>{{farmersDetailsForm.controls.mobileNo.value}}</span>
                        </div>

                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.mobileNo.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.mobileNo.errors.required">{{'MOBILE_NO_IS_REQUIRED'| translate}}</div>

                            <div *ngIf="farmersFormControls.mobileNo.errors.minlength">{{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS'| translate}}
                            </div>
                            <div *ngIf="farmersFormControls.mobileNo.errors.maxlength">{{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS'| translate}}
                            </div>
                            <div *ngIf="farmersFormControls.mobileNo.errors.pattern">{{'MBILE_NO_SHOULD_CONTAIN'| translate}}
                                </div>

                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'CASTE'| translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="caste" value="1" id="IsSubsidyAvailabeYes">
                                    </p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'GEN'| translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="caste" value="2" id="IsSubsidyAvailabeYes">
                                    </p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'BC'| translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="caste" value="3" id="IsSubsidyAvailabeNo">
                                    </p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'SC'| translate}}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="fatherName">{{'ADDRESS'| translate}}</label>
                        <input formControlName="address" pInputText id="fatherName" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.address.errors }" />

                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.address.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.address.errors.required">{{'ADDRESS_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="villageCode">{{'VILLAGE'| translate}}</label>
                        <p-autoComplete formControlName="village" [(ngModel)]="selectedVillageForPersonalDetails" placeholder="SEARCH"
                            id="dd" [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
                            (completeMethod)="filterVillage($event)" field="Name" value="Code"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.village.errors }">
                        </p-autoComplete>

                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.village.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.village.errors.required">{{'VILLAGE_NAME_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="pinCode">{{'PIN_CODE'| translate}}</label>
                        <input maxlength="6" pattern="^[0-9]{6}$" pKeyFilter="int" formControlName="pincode" pInputText
                            id="pinCode" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.pincode.errors }" />

                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.pincode.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.pincode.errors.required">{{'PINCODE_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'AADHAR_NUMBER'| translate}}</label>
                        <input maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int" formControlName="aadharNo"
                            pInputText id="block" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.aadharNo.errors }" />

                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.aadharNo.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.aadharNo.errors.required">{{'AADHAR_NO_IS_REQUIRED'| translate}}</div>
                            <div *ngIf="farmersFormControls.aadharNo.errors.minlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS'| translate}}
                            </div>
                            <div *ngIf="farmersFormControls.aadharNo.errors.maxlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS'| translate}}
                            </div>
                            <div *ngIf="farmersFormControls.aadharNo.errors.pattern">{{'AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'AADHAR_PHOTO'| translate}}</label>
                        <div class="flex">
                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerAadharFileUpload [customUpload]="true"
                                (uploadHandler)="onUpload($event, 'aadharPhotoPath', farmerAadharFileUpload)"
                                name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="Browse" [auto]="true">
                            </p-fileUpload>
                            <p-image *ngIf="farmersFormControls.aadharPhotoPath.value"
                                [src]="farmersFormControls.aadharPhotoPath.value" alt="Image" width="60"
                                class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
                        </div>
                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.aadharPhotoPath.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.aadharPhotoPath.errors.required">{{'AADHAR_PHOTO_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <!-- <label htmlFor="block">PPP ID</label>
                <input formControlName="pppId" pInputText id="block" type="text"
                [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.pppId.errors }" />
      
                <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.pppId.errors" class="invalid-feedback">
                  <div *ngIf="farmersFormControls.pppId.errors.required">PPP ID is required</div>
                </div> -->
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="block">{{'PPP_ID'| translate}}</label>
                        <input formControlName="pppId" pInputText id="block" type="text"
                            [ngClass]="{ 'ng-invalid ng-dirty': isPeronalDetailsSubmitted && farmersFormControls.pppId.errors }" />
                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.pppId.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.pppId.errors.required">{{'PPP_ID_IS_REQUIRED'| translate}}</div>
                            <div *ngIf="farmersFormControls.pppId.errors.minlength">{{'PPP_ID_SHOULD_BE_OF_8DIGITS'| translate}}</div>
                            <div *ngIf="farmersFormControls.pppId.errors.maxlength">{{'PPP_ID_SHOULD_BE_OF_8DIGITS'| translate}}</div>
                        </div>
                    </div>

                    <div class="field col-12 md:col-4">
                        <label htmlFor="fatherName">{{'PPP_PROOF_IMAGE'| translate}}</label>
                        <div class="flex">


                            <p-fileUpload accept=".jpeg,.pdf,.jpg" #farmerPPPFileUpload [customUpload]="true"
                                (uploadHandler)="onUpload($event, 'pppPhotoPath', farmerPPPFileUpload)" name="myfile[]"
                                mode="basic" [maxFileSize]="5000000" chooseLabel="BROWSE" [auto]="true">
                            </p-fileUpload>
                            <p-image *ngIf="farmersFormControls.pppPhotoPath.value"
                                [src]="farmersFormControls.pppPhotoPath.value" alt="Image" width="60"
                                class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>
                        </div>
                        <div *ngIf="isPeronalDetailsSubmitted && farmersFormControls.pppPhotoPath.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmersFormControls.pppPhotoPath.errors.required">{{'PPP_PHOTO_IS_REQUIRED'| translate}}</div>
                        </div>
                    </div>


                </div>
            </form>
            <div>
                <button (click)="onPersonDetailUpdate()" pButton pRipple type="button" label="SAVE"
                    class="p-button-success mr-2 mb-2"></button>
            </div>
        </div>
    </div>
    <!-- personal-details-ends -->

    <!-- bank-details-starts -->
    <div class="bank-details-container" *ngIf="showBankDetailsCard">
        <!-- <p-card styleClass="p-card-shadow bank-details">
            <h5 class="mt-0">Bank Details</h5> -->
        <div class="card bank-details">
            <!-- <p-toolbar styleClass="mb-4">
                    <ng-template pTemplate="left">
                        <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                            class="p-button-success"></button>
                    </ng-template>
                    <ng-template pTemplate="right">
                        <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                            class="p-button-help"></button>
                        <p-menu #menu [popup]="true" [model]="items"></p-menu>
                    </ng-template>
                </p-toolbar> -->

            <p-table #dt [value]="bankAccountList" [rows]="10" [paginator]="true"
                [globalFilterFields]="['accountHolderName','bankName','accountNumber','ifscCode']"
                responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'MANAGE_BANK_ACCOUNTS'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <!-- <th style="width: 3rem">
                                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                            </th> -->
                        <th pSortableColumn="accountHolderName">{{'ACCOUNT_HOLDERS_NAME'| translate}}
                            <p-columnFilter type="text" field="accountHolderName" display="menu"></p-columnFilter>
                            <p-sortIcon field="accountHolderName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="bankName">{{'BANK_NAME'| translate}}
                            <p-columnFilter type="text" field="bankName" display="menu"></p-columnFilter>
                            <p-sortIcon field="bankName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="accountNumber">{{'ACCOUNT_NO'| translate}}
                            <p-columnFilter type="text" field="accountNumber" display="menu"></p-columnFilter>
                            <p-sortIcon field="accountNumber"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ifscCode">{{'IFSC_CODE'| translate}}
                            <p-columnFilter type="text" field="ifscCode" display="menu"></p-columnFilter>
                            <p-sortIcon field="ifscCode"></p-sortIcon>
                        </th>
                        <th pSortableColumn="inventoryStatus">{{'ACTIVE'| translate}}
                            <p-columnFilter type="text" field="inventoryStatus" display="menu"></p-columnFilter>
                            <p-sortIcon field="inventoryStatus"></p-sortIcon>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <!-- <td>
                                <p-tableCheckbox [value]="product"></p-tableCheckbox>
                            </td> -->
                        <td>{{product.accountHolderName}}</td>
                        <td>{{product.bankName}}</td>
                        <td>{{product.accountNumber}}</td>
                        <td> {{product.ifscCode}}
                        <td> {{product.Active}}
                        </td>
                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                (click)="editBankDetails(product)"></button>
                            <!-- <div *ngIf="product.IsDelete == 1">
                                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                        (click)="deleteProduct(product)"></button>
                                </div> -->
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{bankAccountList ? bankAccountList.length : 0 }} {{'BANK_DETAILS_ADDED'| translate}}.
                    </div>
                </ng-template>
            </p-table>
        </div>
        <!-- </p-card> -->
    </div>
    <!-- bank-details-ends -->

    <!-- land-details-starts -->
    <div class="land-details-container" *ngIf="showLandDetailsCard">
        <div class="card land-details" reflow="true">
            <!-- <p-toolbar styleClass="mb-4" reflow="true">
              <ng-template pTemplate="left">
                <button pButton pRipple label="Add Land Details" icon="pi pi-plus" class="p-button-success mr-2"
                  (click)="openNew()"></button>
              </ng-template>
      
              <ng-template pTemplate="right">
                <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                  class="p-button-help"></button>
                <p-menu #menu [popup]="true" [model]="items"></p-menu>
              </ng-template>
            </p-toolbar> -->

            <p-table #dt [value]="lstFarmerLandModel" [rows]="10" [paginator]="true"
                [globalFilterFields]="['Land_ID','Total_Area','Morabba_No','Killa_No','Village']"
                [(selection)]="selectedFarmerLand" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" responsiveLayout="scroll">

                <ng-template pTemplate="caption">
                    <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                        <h5 class="m-0">{{'MANAGE_LAND_DETAILS'| translate}}</h5>
                        <span class="block mt-2 md:mt-0 p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="Land_ID">{{'LAND_ID'| translate}}
                            <p-columnFilter type="text" field="Land_ID" display="menu"></p-columnFilter>
                            <p-sortIcon field="Land_ID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Total_Area">{{'TOTAL_AREA'| translate}}
                            <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Total_Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Morabba_No">{{'MORABBA_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Morabba_No" display="menu"></p-columnFilter>
                            <p-sortIcon field="Morabba_No"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Killa_No">{{'KILLA_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Killa_No" display="menu"></p-columnFilter>
                            <p-sortIcon field="Killa_No"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.Land_ID}}</td>
                        <td>{{product.Total_Area}}</td>
                        <td>{{product.Morabba_No}}</td>
                        <td>{{product.Killa_No}}</td>
                        <td>{{product.VillageName}}</td>
                        <td>
                            <div class="flex justify-content-between">
                                <!-- <div *ngIf="product.IsEdit == 1">
                                    <button pButton pRipple icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success mr-2"
                                        (click)="editProduct(product)"></button>
                                </div> -->
                                <button pButton pRipple icon="pi pi-pencil"
                                    class="p-button-rounded p-button-success mr-2"
                                    (click)="editLandDetails(product)"></button>
                                <!-- <div *ngIf="product.IsDelete == 1">
                        <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                          (click)="deleteProduct(product)"></button>
                      </div> -->
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{lstFarmerLandModel ? lstFarmerLandModel.length : 0 }} {{'LAND_DETAILS_ADDED'| translate}}.
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
    <!-- land-details-ends -->

    <!-- Existing-MI-Details-starts -->
    <div class="existing-MI-details-container" *ngIf="showExistingMIDetailsCard">
        <!-- <p-toolbar styleClass="mb-4" reflow="true">
            <ng-template pTemplate="left">
                <button pButton pRipple label="Add On Farm Mi" icon="pi pi-plus" class="p-button-success mr-2"
                    (click)="openNew()"></button>
            </ng-template>
            <ng-template pTemplate="right">
                <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                    class="p-button-help"></button>
                <p-menu #menu [popup]="true" [model]="items"></p-menu>
            </ng-template>
        </p-toolbar> -->

        <div class="card existing-MI-details" reflow="true">
            <p-table #dt [value]="lstOnFarmMiModel" [rows]="10" [paginator]="true"
                [globalFilterFields]="['Land_ID','Year_subsidy','Water_Quality','Bal_Area','Dept_Subsidy']"
                [(selection)]="selectedOnFarmMi" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" responsiveLayout="scroll">

                <ng-template pTemplate="caption">
                    <div class="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                        <h5 class="m-0">{{'MANAGE_FARM_MI'| translate}}</h5>
                        <span class="block mt-2 md:mt-0 p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="Land_ID">{{'LAND_DETAILS'| translate}}
                            <p-columnFilter type="text" field="Land_ID" display="menu"></p-columnFilter>
                            <p-sortIcon field="Land_ID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Year_subsidy">{{'YEAR_SUBSIDY'| translate}}
                            <p-columnFilter type="text" field="Year_subsidy" display="menu"></p-columnFilter>
                            <p-sortIcon field="Year_subsidy"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Bal_Area">{{'BALANCE_AREA'| translate}}
                            <p-columnFilter type="text" field="Bal_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Bal_Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Dept_Subsidy">{{'DEPARTMENT'| translate}}
                            <p-columnFilter type="text" field="Dept_Subsidy" display="menu"></p-columnFilter>
                            <p-sortIcon field="Dept_Subsidy">
                            </p-sortIcon>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>{{product.landDetailsToDisplay}}</td>
                        <td>{{product.Year_subsidy}}</td>
                        <td>{{product.Bal_Area}}</td>
                        <td>{{product.Dept_Subsidy}}</td>
                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2"
                                (click)="editExistingMIDetails(product)"></button>
                            <div *ngIf="product.IsEdit == 0">
                                <!-- <button pButton pRipple icon="pi pi-pencil"
                                    class="p-button-rounded p-button-success mr-2"
                                    (click)="editExistingMIDetails(product)"></button> -->
                                <!-- <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                (click)="deleteProduct(product)"></button> -->
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{lstOnFarmMiModel ? lstOnFarmMiModel.length : 0 }} {{'LAND_DETAILS_ADDED'| translate}}.
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
    <!-- Existing-MI-Details-ends -->

    <!-- Edit-App-Details-starts -->
    <div class="edit-app-details-container" *ngIf="showEditAppDetailsCard">
        <div class="card col-12 edit-app-details">
            <h6>{{'EDIT_APP_DETAILS'| translate}}</h6>
            <div class="card" reflow="true">
                <h5>{{'FARMERS_APPLICATION'| translate}}</h5>

                <div class="p-fluid p-formgrid grid">
                    <!-- Application Number -->
                    <div class="field col-12 md:col-4">
                        <label htmlFor="appId">{{'SELECT_APPLICATION_ID'| translate}}</label>
                        <p-dropdown [options]="famerAppDetailsforDropDown" [(ngModel)]="selectedFarmerDeatils"
                             (onChange)="onSelectAppId()"
                            placeholder="{{'SELECT_AN_APPLICATION'| translate}}"></p-dropdown>
                    </div>

                    <!-- application type -->
                    <div class="field col-12 md:col-4" *ngIf="applicationId">
                        <label htmlFor="waterSourceType">{{'APPLICATION_TYPE'| translate}}</label>
                        <p-dropdown (onChange)="onApplicationTypeSelected($event)" [options]="schemeMasterList"
                            placeholder="{{'SELECT_APPLICATION_TYPE'| translate}}" optionLabel="type" optionValue="type"
                            [(ngModel)]="applicationSelected">
                        </p-dropdown>
                    </div>

                    <!-- village type -->
                    <div class="field col-12 md:col-4" *ngIf="applicationId">
                        <label htmlFor="waterSourceType">{{'VILLAGE'| translate}}</label>
                        <p-autoComplete placeholder="Vilage Search" id="dd" [dropdown]="true" [multiple]="false"
                            [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)" field="Name"
                            (onSelect)="onVillageSelect($event)" [(ngModel)]="selectedVillageForEditAppDetails"></p-autoComplete>
                    </div>

                    <!-- water source type -->
                    <div class="field col-12 md:col-4" *ngIf="waterSourceTypeList.length">
                        <label htmlFor="waterSourceType">{{'WATER_SOURCE_TYPE'| translate}}</label>
                        <p-dropdown [options]="waterSourceTypeList" (onChange)="onWaterSourceTypeSelected($event)"
                            placeholder="{{'SELECT_WATER_SOURCE_TYPE'| translate}}" optionLabel="waterSource" optionValue="waterSource"
                            [(ngModel)]="selectedWatersourceType"></p-dropdown>
                    </div>

                    <!-- component -->
                    <div class="field col-12 md:col-4" *ngIf="componentList.length">
                        <label htmlFor="waterSourceType">{{'COMPONENTS'| translate}}</label>
                        <p-dropdown [options]="componentList" optionLabel="component"
                            (onChange)="onComponentSelected($event)" placeholder="{{'SELECT_A_COMPONENT'| translate}}"
                            [(ngModel)]="componentSelected"></p-dropdown>
                    </div>
                </div>
            </div>
            <div class="card" reflow="true" *ngIf="applicationSelected === 'Group' || applicationSelected === 'WUA'">
                <div class="p-fluid p-formgrid grid">
                    <!-- add farmer in group -->
                    <div class="field col-12 md:col-12">
                        <p-toolbar styleClass="mb-4">
                            <ng-template pTemplate="left">
                                <button pButton icon="pi pi-fw pi-plus" label="{{'ADD_FARMERS_IN_GROUP'| translate}}"
                                    class="p-button-success" (click)="addFarmersInGroup()"></button>

                                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
                            </ng-template>
                            <ng-template pTemplate="right">
                                <button class="mr-1" *ngIf="consentUploadPath" pButton pRipple label="UPLOADED_CONSENTt"
                                    icon="pi pi-plus" class="p-button-help mr-2"
                                    (click)="openPreviousConsent(consentUploadPath)"></button>

                                <button class="mr-1" *ngIf="applicationSelected === 'Group'" pButton pRipple
                                    label="{{'NEW_CONSENT_FORM'| translate}}" icon="pi pi-plus" class="p-button-help mr-2"
                                    (click)="downloadConsent()"></button>

                                <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true"
                                    #farmerApplicationConsentPathUpload
                                    (uploadHandler)="onUpload($event, 'consentForm', farmerApplicationConsentPathUpload)"
                                    name="myfile[]" mode="basic" [maxFileSize]="5000000" chooseLabel="Upload"
                                    [auto]="true">
                                </p-fileUpload>
                            </ng-template>
                        </p-toolbar>

                        <p-table class="mt-2" #dt [value]="selectedFarmersLandList" [rows]="10" [paginator]="true"
                            [globalFilterFields]="['farmer_Id','farmersName','landId', 'village']"
                            responsiveLayout="scroll" [(selection)]="selectedBankAccounts" [rowHover]="true"
                            dataKey="id" currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                            [showCurrentPageReport]="true">
                            <ng-template pTemplate="caption">
                                <div class="flex align-items-center justify-content-between">
                                    <h5 class="m-0">{{'MANAGE_FARMERS_LIST'| translate}}</h5>
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="{{'SEARCH'| translate}}" />
                                    </span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>

                                    <th pSortableColumn="farmer_Id">{{'FARMER_ID'| translate}}
                                        <p-columnFilter type="text" field="farmer_Id" display="menu"></p-columnFilter>
                                        <p-sortIcon field="farmer_Id"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="farmersName">{{'FARMERS_NAME'| translate}}
                                        <p-columnFilter type="text" field="farmersName" display="menu"></p-columnFilter>
                                        <p-sortIcon field="farmersName"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="landId">{{'LAND_ID_'| translate}}
                                        <p-columnFilter type="text" field="landId" display="menu"></p-columnFilter>
                                        <p-sortIcon field="landId"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="village">{{'VILLAGE'| translate}}
                                        <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                                        <p-sortIcon field="village"></p-sortIcon>
                                    </th>
                                    <th></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>

                                    <td>{{product.farmer_Id}}</td>
                                    <td>{{product.farmersName}}</td>
                                    <td>{{product.landID}}</td>
                                    <td>{{product.village}}</td>
                                    <td>
                                        <button pButton pRipple icon="pi pi-pencil"
                                            class="p-button-rounded p-button-success mr-2"
                                            (click)="editFarmersInGroup(product)"></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="flex align-items-center justify-content-between">
                                    {{'IN_TOTAL_THERE_ARE'| translate}}
                                    {{selectedFarmersLandList ? selectedFarmersLandList.length : 0 }} {{'FARMERS_ADDED'| translate}}.
                                </div>
                            </ng-template>
                        </p-table>

                    </div>
                </div>
            </div>


            <div class="card" reflow="true" *ngIf="componentSelected?.component?.includes('MI')">
                <h5>{{'MI_FORM'}}</h5>
                <button pButton icon="pi pi-fw pi-plus" label="{{'ADD_MI_DETAILS'| translate}}" (click)="openNew()"
                    class="p-button-success mb-4"></button>

                <p-table class="mt-2" #dt [value]="miDetailsList" [rows]="10" [paginator]="true"
                    [globalFilterFields]="['mi','vendor','landId', 'totalArea']" responsiveLayout="scroll"
                    [(selection)]="selectedBankAccounts" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                    [showCurrentPageReport]="true">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items-center justify-content-between">
                            <h5 class="m-0">{{'MANAGE_MI_LIST'}}</h5>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                                    placeholder="{{'SEARCH'| translate}}" />
                            </span>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="mi">{{'COMPONENT'| translate}}
                                <p-columnFilter type="text" field="mi" display="menu"></p-columnFilter>
                                <p-sortIcon field="mi"></p-sortIcon>
                            </th>
                            <th pSortableColumn="vendor">{{'VENDOR'| translate}}
                                <p-columnFilter type="text" field="vendor" display="menu"></p-columnFilter>
                                <p-sortIcon field="vendor"></p-sortIcon>
                            </th>
                            <th pSortableColumn="landId">{{'LAND_ID_'| translate}}
                                <p-columnFilter type="text" field="landId" display="menu"></p-columnFilter>
                                <p-sortIcon field="landId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="totalArea">{{'TOTAL_AREA_ACRE'| translate}}
                                <p-columnFilter type="text" field="totalArea" display="menu"></p-columnFilter>
                                <p-sortIcon field="totalArea"></p-sortIcon>
                            </th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>{{product.mi}}</td>
                            <td>{{product.vendor}}</td>
                            <td>{{product.landData}}</td>
                            <td>{{product.totalArea}}</td>
                            <td>
                                <button pButton pRipple icon="pi pi-pencil"
                                    class="p-button-rounded p-button-success mr-2"
                                    (click)="editProduct(product)"></button>

                                <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning"
                                    (click)="deleteProduct(product)"></button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between">
                            {{'IN_TOTAL_THERE_ARE'| translate}}
                            {{miDetailsList ? miDetailsList.length : 0 }} {{'COMPONENT_DETAILS_ADDED'| translate}}.
                        </div>
                    </ng-template>
                </p-table>
                <!-- </div> -->

            </div>
            <div class="card" reflow="true" *ngIf="componentSelected?.component?.includes('Pond')">
                <h5>{{'POND_FORM'| translate}}</h5>
                <!-- <div class="p-fluid p-formgrid grid"> -->
                <form [formGroup]="onFarmPondApplicatonForm" class="p-fluid p-formgrid grid">
                    <!-- <div class="col-12 flex-wrap" > -->
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'LAND_ID_'| translate}} </label>
                        <p-dropdown [options]="landIDList" formControlName="landId" optionLabel="displayName"
                            optionValue="LandID" placeholder="{{'SELECT_LAND_IDS'| translate}}"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedPondApplicatonForm && farmPondApplicatonFormControls.landId.errors || farmPondApplicatonFormControls.landId.touched && farmPondApplicatonFormControls.landId.errors}">
                        </p-dropdown>
                        <div *ngIf="isSubmittedPondApplicatonForm && farmPondApplicatonFormControls.landId.errors || farmPondApplicatonFormControls.landId.touched && farmPondApplicatonFormControls.landId.errors"
                            class="invalid-feedback">
                            <div *ngIf="farmPondApplicatonFormControls.landId.errors.required">
                                {{'LAND_ID_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'SIZE_COVERAGE_AREA'| translate}}</label>
                        <p-dropdown [options]="tankListMaster" (onChange)="onCoverageAreaSelected($event)"
                            formControlName="sizeCoverageArea" optionLabel="Coverage_Area"
                            placeholder="{{'SELECT_COVERAGE_AREA'| translate}}" [(ngModel)]="coverageAreaSelected"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedPondApplicatonForm && coverageAreaSelected['Tank_ID'] == undefined || farmPondApplicatonFormControls.sizeCoverageArea.touched && coverageAreaSelected['Tank_ID'] == undefined}">
                        </p-dropdown>
                        <div *ngIf="isSubmittedPondApplicatonForm && coverageAreaSelected['Tank_ID'] == undefined || farmPondApplicatonFormControls.sizeCoverageArea.touched && coverageAreaSelected['Tank_ID'] == undefined"
                            class="invalid-feedback">
                            <div>
                                {{'SIZE_COVERAGE_AREA_IA_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'TOP'| translate}}</label>
                        <input readonly formControlName="topSize" pInputText id="tankId" type="text" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'BOTTOM'| translate}} </label>
                        <input readonly formControlName="bottomSize" pInputText id="latitude" type="text" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'DEPTH_FT'| translate}}</label>
                        <input readonly formControlName="depth" pInputText id="longitude" type="text" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'WATER_CAPACITY_IN'| translate}}</label>
                        <input readonly formControlName="waterCapacity" pInputText id="canalName" type="text" />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'TENATIVE_COST'| translate}}</label>
                        <input readonly formControlName="tenativeCost" pInputText id="canalName" type="text" />
                    </div>
                </form>
            </div>

            <div class="card" reflow="true" *ngIf="componentSelected?.component?.includes('Solar')">
                <h5>{{'SOLAR_PUMP_DETAIL'}}</h5>
                <form [formGroup]="solarApplicatonForm" class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'LAND_ID_'| translate}}</label>
                        <p-dropdown [options]="landIDList" formControlName="landId" optionLabel="displayName"
                            optionValue="LandID" placeholder="{{'SELECT_LAND_IDS'| translate}}"
                            (onChange)="onSolarLandIdSelected($event)"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedSolarApplicatonFrom && solarApplicatonFormControls.landId.errors || solarApplicatonFormControls.landId.touched && solarApplicatonFormControls.landId.errors}">
                        </p-dropdown>
                        <div *ngIf="isSubmittedSolarApplicatonFrom && solarApplicatonFormControls.landId.errors || solarApplicatonFormControls.landId.touched && solarApplicatonFormControls.landId.errors"
                            class="invalid-feedback">
                            <div *ngIf="solarApplicatonFormControls.landId.errors.required">
                                {{'LAND_ID_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'PUMP_CONTROLLER_TYPE'| translate}} </label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="controlType" value="Normal"
                                        id="IsSubsidyAvailabeYes" (onClick)="validateAndGetSolarVendors()">
                                    </p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'NORMAL_SOLAR_PUMP_COMTROLLER'| translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="controlType" value="Universial"
                                        id="IsSubsidyAvailabeNo" (onClick)="validateAndGetSolarVendors()">
                                    </p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'UNIVERSAL_SOLAR_PUMP_CONTROLLER'| translate}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'PUMP_TYPE'| translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="pump" value="Surface" id="IsSubsidyAvailabeYes"
                                        (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'SURFACE_PUMP'| translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="pump" value="Submersible" id="IsSubsidyAvailabeNo"
                                        (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'SUBMERSIBLE_PUMP'| translate}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'SOLAR_PUMP_CATEGORY'| translate}}</label>
                        <div class="formgroup-inline">
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="pumpType" value="AC" id="IsSubsidyAvailabeYes"
                                        (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                                    <label for="IsSubsidyAvailabeYes">{{'AC'| translate}}</label>
                                </div>
                            </div>
                            <div class="field">
                                <div class="field-radiobutton mb-0">
                                    <p-radioButton formControlName="pumpType" value="DC" id="IsSubsidyAvailabeNo"
                                        (onClick)="validateAndGetSolarVendors()"></p-radioButton>
                                    <label for="IsSubsidyAvailabeNo">{{'DC'| translate}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'CAPACITY_OF_SOLAR_PUMP'| translate}} </label>
                        <p-dropdown [options]="pumpCapacityList" formControlName="pumpCapacity" optionLabel="name"
                            optionValue="name" (onChange)="onCapacityOfPumpSelected($event)"
                            placeholder="{{'SELECT_A_CAPACITY'| translate}}"></p-dropdown>
                    </div>

                    <div class="field col-12 md:col-4" *ngIf="primarySolarVendorList.length">
                        <label htmlFor="waterSourceType">{{'PRIMARY_VENDOR'| translate}} </label>
                        <p-dropdown [options]="primarySolarVendorList" formControlName="primaryVendor"
                            optionLabel="Primary_Vendor" optionValue="Primary_Vendor"
                            placeholder="{{'SELECT_A_PRIMAR'| translate}}" (onChange)="onPrimarySolarVendorChange($event)"
                            [(ngModel)]="selectedPrimarySolarVendor"></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-4" *ngIf="secondarySolarVendorList.length">
                        <label htmlFor="waterSourceType">{{'SECONDARY_VENDOR'| translate}}</label>
                        <p-dropdown [options]="secondarySolarVendorList" formControlName="secondaryVendor"
                            optionLabel="Secondary_Vendor" optionValue="Secondary_Vendor"
                            [(ngModel)]="selectedSecondarySolarVendor" placeholder="{{'SELECT_A_SCONDA'| translate}}"
                            (onChange)="onSecondarySolarVendorChange($event)"></p-dropdown>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="farmerName">{{'FARMER_SHARE_TOTAL'| translate}}</label>
                        <input formControlName="farmerShare" readonly pInputText id="farmerName" type="text" />
                    </div>
                </form>
            </div>

            <div class="card" reflow="true"
                *ngIf="selectedWatersourceType == 'Canal' || selectedWatersourceType == 'STP'">
                <h5>{{'WATER_COURSE_FORM'| translate}}</h5>
                <form [formGroup]="watercourseApplicatonForm" class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'CANAL'| translate}}</label>
                        <p-dropdown [options]="canalOutletList" *ngIf="canalOutletList?.length" formControlName="canal"
                            optionLabel="canal" optionValue="canal" (onChange)="onCanalOutletSelected($event)"
                            placeholder="{{'SELECT_CANAL'| translate}}"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedWaterCourseFrom && watercourseFormControls.canal.errors || watercourseFormControls.canal.touched && watercourseFormControls.canal.errors}">
                        </p-dropdown>
                        <div *ngIf="isSubmittedWaterCourseFrom && watercourseFormControls.canal.errors || watercourseFormControls.canal.touched && watercourseFormControls.canal.errors"
                            class="invalid-feedback">
                            <div *ngIf="watercourseFormControls.canal.errors.required">
                                {{'CANAL_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4" *ngIf="outletTypeList?.length">
                        <label htmlFor="waterSourceType">{{'OUTLET'| translate}}</label>
                        <p-dropdown [options]="outletTypeList" formControlName="outlet" optionLabel="outletName"
                            optionValue="recordID" placeholder="{{'SELECT_A_OUTLET'| translate}}"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedWaterCourseFrom && watercourseFormControls.outlet.errors || watercourseFormControls.outlet.touched && watercourseFormControls.outlet.errors}">
                        </p-dropdown>
                        <div *ngIf="isSubmittedWaterCourseFrom && watercourseFormControls.outlet.errors || watercourseFormControls.outlet.touched && watercourseFormControls.outlet.errors"
                            class="invalid-feedback">
                            <div *ngIf="watercourseFormControls.outlet.errors.required">
                                {{'OUTLET_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="waterSourceType">{{'WORK_TYPE'| translate}}</label>
                        <p-dropdown [options]="workTypeMasterList" formControlName="workType" optionLabel="workType"
                            optionValue="workTypeID" placeholder="select a work type"
                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedWaterCourseFrom && watercourseFormControls.workType.errors || watercourseFormControls.workType.touched && watercourseFormControls.workType.errors }">
                        </p-dropdown>
                        <div *ngIf="isSubmittedWaterCourseFrom && watercourseFormControls.workType.errors || watercourseFormControls.workType.touched && watercourseFormControls.workType.errors"
                            class="invalid-feedback">
                            <div *ngIf="watercourseFormControls.workType.errors.required">
                                {{'WORKTYPE_IS_REQUIRED'| translate}}
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-12">
                        <div class="field-checkbox mb-0">
                            <p-checkbox name="group1" value="true" formControlName="checkBox" id="ch"
                                [ngClass]="{ 'ng-invalid ng-dirty': isSubmittedWaterCourseFrom && watercourseFormControls.checkBox.errors || watercourseFormControls.checkBox.touched && watercourseFormControls.checkBox.errors }">
                            </p-checkbox>
                            <label for="ch">{{'I_AGREE_WITH_ALL_TERM_&_CONDITION'| translate}}</label>
                        </div>
                        <div *ngIf="isSubmittedWaterCourseFrom && watercourseFormControls.checkBox.errors || watercourseFormControls.checkBox.touched && watercourseFormControls.checkBox.errors"
                            class="invalid-feedback">
                            <div *ngIf="watercourseFormControls.checkBox.errors.required">
                                {{'SELECT_CHECKBOX'| translate}}
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="card" reflow="true"
                *ngIf="componentSelected?.component?.includes('Solar') || componentSelected?.component?.includes('Pond')|| componentSelected?.component?.includes('MI')">
                <h5>{{'SELECT_BENEFICIARY_BANK'| translate}}</h5>
                <p-dropdown class="w-100" [options]="bankAccountListForEditApp" optionLabel="displayName" optionValue="Account_NO"
                    (onChange)="onBankAccountSelected($event)" placeholder="{{'SELECT_A_BANK_ACCOUNT'| translate}}"
                    [(ngModel)]="bankAccountSelected">
                </p-dropdown>

            </div>
            <div class="card" reflow="true">
                <button (click)="onFarmersApplicationFormSubmit()" pButton pRipple type="button" label="Save"
                    class="p-button-success mr-2 mb-2 mt-2"
                    [disabled]="componentSelected == undefined || componentSelected == null"></button>
            </div>
        </div>
    </div>
    <!-- Edit-App-Details-end -->
</div>

<!-- bank-details-dialog-box-->
<p-dialog [(visible)]="openBankDialog" [style]="{width: '600px'}" header="Add Bank Details" [modal]="true"
    styleClass="p-fluid" (onHide)="hideBankDialog()">
    <ng-template pTemplate="content">
        <div class="field">
            <label for="name">{{'ACCOUNT_HOLDER_NAME'| translate}}</label>
            <input type="text" pInputText id="name" [(ngModel)]="bankAccount.accountHolderName" required autofocus />
            <small class="p-error" *ngIf="bankDetailsSubmitted && !bankAccount.accountHolderName">{{'NAME_IS_REQUIRED'| translate}}.</small>
        </div>
        <div class="field">
            <label for="description">{{'ACCOUNT_NUMBER'| translate}}</label>
            <input type="text" pInputText id="name" [(ngModel)]="bankAccount.accountNumber" required autofocus />
            <small class="p-error" *ngIf="bankDetailsSubmitted && !bankAccount.accountNumber">{{'NAME_IS_REQUIRED'| translate}}.</small>
            <div class="formgrid grid mt-3">
                <div class="field col">
                    <label for="inventoryStatus">{{'BANK_NAME'| translate}}</label>
                    <p-autoComplete [ngModelOptions]="{standalone: true}" [(ngModel)]="bank_Name"
                        placeholder="{{'SELECT_NAME_OF_BANK'| translate}}" id="dd" [dropdown]="true" [multiple]="false"
                        [suggestions]="filteredBankList" optionLabel="Bank_NAME" (completeMethod)="filterBank($event)"
                        field="Bank_NAME" value="BANK_ID"></p-autoComplete>
                </div>
                <div class="field col">
                    <label for="inventoryStatus">{{'IFSC_CODE'| translate}}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="bankAccount.ifscCode" required autofocus />
                </div>
            </div>
            <div class="field">
                <label for="inventoryStatus">{{'PASSBOOK_PHOTO_UPLOAD'| translate}}</label>
                <div class="flex">
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerBankPassBookUpload
                        (uploadHandler)="onUpload($event, 'passbookImage', farmerBankPassBookUpload)" name="myfile[]"
                        mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE'| translate}}" [auto]="true">
                    </p-fileUpload>
                    <p-image *ngIf="bankAccount.image" [src]="bankAccount.image" alt="Image" width="60"
                        class="ml-2 p-button-rounded p-button-success" iconPos="left"></p-image>

                </div>
                <div *ngIf="bankDetailsSubmitted && !bankAccount.image" class="invalid-feedback">
                    <div *ngIf="!bankAccount.image">{{'FARMERS_PHOTO_IS_REQUIRED'| translate}}</div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text"
            (click)="hideBankDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text"
            (click)="saveBankDetails()"></button>
    </ng-template>
</p-dialog>
<!-- bank-details-dialog-box-end -->


<!-- land-details-dialog-box -->
<p-dialog [(visible)]="openLandDialog" (onHide)="hideLandDialog()"
    [style]="{width: innerWidth < 500 ?'400px' : '730px', height: '70vh'}" header="Land Details" [modal]="true"
    reflow="true" class="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="farmerLandForm">
            <div class="grid p-fluid mt-3">
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <input pInputText inputId="morabbaNumber" type="text" class="form-control"
                            formControlName="morabbaNumber" autofocus="" tabindex="1"
                            [ngClass]="{ 'ng-invalid ng-dirty': landDetailsSubmitted && f.morabbaNumber.errors }" />
                        <div *ngIf="landDetailsSubmitted && f.morabbaNumber.errors" class="invalid-feedback">
                            <div *ngIf="f.morabbaNumber.errors.required">{{'MORABBA_NUMBER_IS_REQUIRED'| translate}}</div>
                        </div>
                        <label for="morabbaNumber">{{'MORABBA_NUMBER'| translate}}</label>
                    </span>
                </div>
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <input pInputText inputId="killaNumber" type="text" class="form-control"
                            formControlName="killaNumber" autofocus="" tabindex="1"
                            [ngClass]="{ 'ng-invalid ng-dirty': landDetailsSubmitted && f.killaNumber.errors }" />
                        <div *ngIf="landDetailsSubmitted && f.killaNumber.errors" class="invalid-feedback">
                            <div *ngIf="f.killaNumber.errors.required">{{'KILLA_NUMBER_IS_REQUIRED'| translate}}</div>
                        </div>
                        <label for="killaNumber">{{'KILLA_NUMBER'| translate}}</label>
                    </span>
                </div>
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <input readonly pInputText id="totalArea" class="form-control" type="text"
                            formControlName="totalArea" autofocus="" tabindex="1"
                            [ngClass]="{ 'ng-invalid ng-dirty': landDetailsSubmitted && f.totalArea.errors }" />
                        <div *ngIf="landDetailsSubmitted && f.totalArea.errors" class="invalid-feedback">
                            <div *ngIf="f.totalArea.errors.required">{{'TOTAL_AREA_IS_REQUIRED'| translate}}</div>
                        </div>
                        <label for="totalArea">{{'TOTAL_AREA'| translate}}</label>
                    </span>
                </div>

                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <input pInputText id="kanals" class="form-control" type="text" formControlName="kanals"
                            autofocus="" tabindex="1"
                            [ngClass]="{ 'ng-invalid ng-dirty': landDetailsSubmitted && f.kanals.errors }"
                            (keyup)="onKanalsChange()" />
                        <div *ngIf="landDetailsSubmitted && f.kanals.errors" class="invalid-feedback">
                            <div *ngIf="f.kanals.errors.required">{{'KANNALS_IS_REQUIRED'| translate}}"</div>
                            <div *ngIf="f.kanals.errors.max">{{'KANAL_CANNOT_BE_GREATER'| translate}}.</div>
                        </div>
                        <label for="kanals">{{'AREA_IN_KANALS'| translate}}</label>
                    </span>
                </div>
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <input maxlength="2" pattern="^([0-1]?[0-9])$" pKeyFilter="int" pInputText id="marlas"
                            class="form-control" type="text" formControlName="marlas" autofocus="" tabindex="1"
                            [ngClass]="{ 'ng-invalid ng-dirty': landDetailsSubmitted && f.marlas.errors }"
                            (keyup)="onMarlasChange()" />
                        <div *ngIf="landDetailsSubmitted && f.marlas.errors" class="invalid-feedback">
                            <div *ngIf="f.marlas.errors.required">{{'MARLAS_IS_REQUIRED'| translate}}</div>
                        </div>
                        <label for="marlas">{{'AREA_IN_MARLAS'| translate}}</label>
                    </span>
                </div>
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <p-treeSelect formControlName="cropType" [(ngModel)]="selectedNodes1" [options]="nodes2"
                            [metaKeySelection]="false" selectionMode="checkbox" placeholder="{{'SELECT_CROP_TYPE'}}">
                        </p-treeSelect>

                        <div *ngIf="landDetailsSubmitted && f.cropType.errors" class="invalid-feedback">
                            <div *ngIf="f.cropType.errors.required">{{'CROP_TYPE_IS_REQUIRED'| translate}}</div>
                        </div>
                    </span>
                </div>
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <p-autoComplete formControlName="village" [(ngModel)]="selectedVillageForLandDetails"
                            placeholder="{{'VILAGE_SEARCH'| translate}}" id="dd" [dropdown]="true" [multiple]="false"
                            [suggestions]="filteredVillage" (completeMethod)="filterVillage($event)" field="Name"
                            [ngClass]="{ 'ng-invalid ng-dirty': landDetailsSubmitted && f.village.errors }">
                        </p-autoComplete>

                        <div *ngIf="landDetailsSubmitted && f.village.errors" class="invalid-feedback">
                            <div *ngIf="f.village.errors.required">{{'VILLAGE_IS_REQUIRED'| translate}}</div>
                        </div>
                    </span>
                </div>
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <input pInputText id="latitude" class="form-control" type="text" formControlName="latitude"
                            autofocus="" tabindex="1"
                            [ngClass]="{ 'ng-invalid ng-dirty': landDetailsSubmitted && f.latitude.errors }" />
                        <div *ngIf="landDetailsSubmitted && f.latitude.errors" class="invalid-feedback">
                            <div *ngIf="f.latitude.errors.required">{{'LATITUDE_IS_REQUIRED'| translate}}</div>
                        </div>
                        <label for="latitude">{{'LATITUDE'| translate}} </label>
                    </span>
                </div>
                <div class="field col-12 md:col-4">
                    <span class="p-float-label">
                        <input pInputText id="longitude" class="form-control" type="text" formControlName="longitude"
                            autofocus="" tabindex="1"
                            [ngClass]="{ 'ng-invalid ng-dirty': landDetailsSubmitted && f.longitude.errors }" />
                        <div *ngIf="landDetailsSubmitted && f.longitude.errors" class="invalid-feedback">
                            <div *ngIf="f.longitude.errors.required">{{'LONGITUDE_IS_REQUIRED'| translate}}</div>
                        </div>
                        <label for="longitude ">{{'LONGITUDE'| translate}} </label>
                    </span>
                    <p class="text-message" (click)="setCurrentPosition()">{{'FIND_MY_CURRENT_LOCATION'| translate}}</p>
                </div>

                <div class="field  col-12 md:col-4">
                    <label class="mb-3">{{'LEASE_LAND'| translate}}</label>
                    <div class="formgrid grid">
                        <div class="field-radiobutton col-4">
                            <p-radioButton name="IsSubsidyAvailabe" [value]="true" [(ngModel)]="valRadio"
                                formControlName="IsSubsidyAvailabe" id="IsSubsidyAvailabeYes">
                            </p-radioButton>
                            <label for="IsSubsidyAvailabeYes">{{'YES'| translate}}</label>
                        </div>
                        <div class="field-radiobutton col-8">
                            <p-radioButton name="IsSubsidyAvailabe" [value]="false" [(ngModel)]="valRadio"
                                formControlName="IsSubsidyAvailabe" id="IsSubsidyAvailabeNo">
                            </p-radioButton>
                            <label for="IsSubsidyAvailabeNo">{{'NO'| translate}}</label>
                        </div>
                    </div>
                </div>
                <div class="field col-12 md:col-4">
                    <div class="flex">
                        <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerLandLocUpload
                            (uploadHandler)="onUpload($event, 'landdoc_Path', farmerLandLocUpload)" name="myfile[]"
                            mode="basic" [maxFileSize]="5000000" chooseLabel="{{'UPLOAD_DOCUMENTS'| translate}}" [auto]="true">
                        </p-fileUpload>
                        <p-image *ngIf="f.landdoc_Path.value" [src]="f.landdoc_Path.value" alt="Image" width="60"
                            class="ml-2" iconPos="left"></p-image>
                    </div>
                    <div *ngIf="landDetailsSubmitted && f.landdoc_Path.errors" class="invalid-feedback">
                        <div *ngIf="f.landdoc_Path.errors.required">{{'LAND_DOCUMENT_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-4" *ngIf="valRadio">
                    <div class="flex">
                        <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerLeaseDocUpload
                            (uploadHandler)="onUpload($event, 'leaseDoc_Path', farmerLeaseDocUpload)" name="myfile[]"
                            mode="basic" [maxFileSize]="5000000" chooseLabel="{{'UPLOAD_LEASE_DOCUMENTS'| translate}}" [auto]="true">
                        </p-fileUpload>
                        <p-image *ngIf="f.leaseDoc_Path.value" [src]="f.leaseDoc_Path.value" alt="Image" width="60"
                            class="ml-2" iconPos="left"></p-image>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text"
            (click)="hideLandDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text"
            (click)="onLandDetailsSubmit()"></button>
    </ng-template>
</p-dialog>
<!-- land-details-dialog-box-end -->

<!-- existing-MI-details-dialog-box-starts -->
<p-dialog [(visible)]="openExistingMIDialog" [style]="{width: innerWidth < 500 ?'400px' : '500px'}"
    header="Existing On Farm MI" [modal]="true" reflow="true" class="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="onFarmMIForm">
            <div class="grid p-fluid mt-2">
                <div class="field col-12 md:col-6">
                    <label htmlFor="state">{{'IS_SUBSIDY_AVAILED'| translate}}?</label>
                    <div class="formgroup-inline">
                        <div class="field">
                            <div class="field-radiobutton mb-0">
                                <p-radioButton [value]="1" formControlName="isSubsidyAvailabe"
                                    [(ngModel)]="isSubsidyAvailabe" id="IsSubsidyAvailabeYes"></p-radioButton>
                                <label for="IsSubsidyAvailabeYes">{{'YES'| translate}}</label>
                            </div>
                        </div>
                        <div class="field">
                            <div class="field-radiobutton mb-0">
                                <p-radioButton [value]="0" formControlName="isSubsidyAvailabe"
                                    [(ngModel)]="isSubsidyAvailabe" id="IsSubsidyAvailabeNo">
                                </p-radioButton>
                                <label for="IsSubsidyAvailabeNo">{{'NO'| translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid p-fluid mt-3">
                <div class="field col-12 md:col-6">
                    <label htmlFor="address">{{'LAND'| translate}}</label>

                    <p-autoComplete formControlName="landDetails" [(ngModel)]="selectedLandDetail"
                        [suggestions]="filteredLandDetails" (completeMethod)="filterLandDetails($event)"
                        (onSelect)="changeLD()" field="description" value="LandID" id="dd" [dropdown]="true"
                        [ngClass]="{ 'g-invalid ng-dirty': existingMIDetailsSubmitted && fMI.landDetails.errors }">
                    </p-autoComplete>

                    <div *ngIf="existingMIDetailsSubmitted && fMI.landDetails.errors" class="invalid-feedback">
                        <div *ngIf="fMI.landDetails.errors.required">{{'LAND_DETAILS_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="address">{{'COMPONENT'| translate}}</label>

                    <p-autoComplete [(ngModel)]="selectedcompMaster" formControlName="componentMaster"
                        placeholder="Component Master Search" id="Program_Id" [dropdown]="true" [multiple]="false"
                        [suggestions]="filteredComponentMaster" (completeMethod)="filterComponentMaster($event)"
                        field="Program_Name"
                        [ngClass]="{ 'g-invalid ng-dirty': existingMIDetailsSubmitted && fMI.componentMaster.errors }">
                    </p-autoComplete>
                    <div *ngIf="existingMIDetailsSubmitted && fMI.componentMaster.errors" class="invalid-feedback">
                        <div *ngIf="fMI.componentMaster.errors.required">{{'COMPONENT_MASTER_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
            </div>

            <div class="grid p-fluid mt-3" *ngIf="isSubsidyAvailabe == 1">
                <div class="field col-12 md:col-6">
                    <label htmlFor="departmentSubsidy">{{'DEPARTMENT'| translate}}</label>
                    <p-dropdown [options]="departmentList" formControlName="departmentSubsidy" optionValue="name"
                        optionLabel="name" placeholder="{{'SELECT_A_DEPARTMENT'| translate}}">
                    </p-dropdown>


                    <div *ngIf="existingMIDetailsSubmitted && fMI.departmentSubsidy.errors" class="invalid-feedback">
                        <div *ngIf="fMI.departmentSubsidy.errors.required">{{'DEPARTMANT_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="yearSubsudy">{{'YEAR'| translate}}</label>
                    <input pInputText id="yearSubsudy" class="form-control" type="text" formControlName="yearSubsudy"
                        autofocus="" tabindex="1"
                        [ngClass]="{ 'ng-invalid ng-dirty': existingMIDetailsSubmitted && fMI.yearSubsudy.errors }" />
                    <div *ngIf="existingMIDetailsSubmitted && fMI.yearSubsudy.errors" class="invalid-feedback">
                        <div *ngIf="fMI.yearSubsudy.errors.required">{{'YEAR_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
            </div>
            <div class="grid p-fluid mt-3" *ngIf="isSubsidyAvailabe == 0">
                <div class="field col-12 md:col-6">
                    <label htmlFor="subsidyArea">{{'SUBSIDY_AREA'| translate}}</label>
                    <input pInputText id="subsidyArea" class="form-control" type="text" formControlName="subsidyArea"
                        autofocus="" tabindex="1"
                        [ngClass]="{ 'ng-invalid ng-dirty': existingMIDetailsSubmitted && fMI.subsidyArea.errors }"
                        (change)="subsidyAreachange($event)" />
                    <div *ngIf="existingMIDetailsSubmitted && fMI.subsidyArea.errors" class="invalid-feedback">
                        <div *ngIf="fMI.subsidyArea.errors.required">{{'TOTAL_AREA_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="balanceArea">{{'BALANCE_AREA'| translate}}</label>
                    <p-inputNumber [useGrouping]="false" inputId="balanceArea" class="form-control"
                        formControlName="balanceArea" autofocus="" tabindex="1"
                        [ngClass]="{ 'ng-invalid ng-dirty': existingMIDetailsSubmitted && fMI.balanceArea.errors }">
                    </p-inputNumber>
                    <div *ngIf="existingMIDetailsSubmitted && fMI.balanceArea.errors" class="invalid-feedback">
                        <div *ngIf="fMI.balanceArea.errors.required">{{'BALANCE_AREA_IS_REQUIRED'| translate}}</div>
                    </div>
                </div>
            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text"
            (click)="hideExistingMIDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text"
            (click)="onExistingMISubmit()"></button>
    </ng-template>
</p-dialog>
<!-- existing-MI-details-dialog-box-starts -->

<!-- edit-App-details-dialog-box-starts -->
<!-- dialog to add micomponent -->
<p-dialog [(visible)]="addBankDialog" [style]="{ width: '1000px', height: '700px' }" header="Add MI Details"
    [modal]="true" styleClass="p-fluid">
    <ng-template pTemplate="content">
        <form [formGroup]="miApplicatonForm">

            <div class="grid p-fluid">
                <div class="field col-12">
                    <label htmlFor="state">{{'SUBSIDY_ALREADY_TAKEN_FORM_DEPARTMENT'| translate}}</label>
                    <p-table [value]="farmerPreviousSubsidies" responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{'APP_ID'| translate}}</th>
                                <th>{{'DEPARTMENT'| translate}}</th>
                                <th>{{'AREA'| translate}}</th>
                                <th>{{'SUBSIDY_YEAR'| translate}}</th>
                                <th>{{'AADHAR_NUMBER'| translate}}</th>
                                <th>{{'SYSTEM'| translate}}</th>
                                <th>{{'LAND_DETAIL'| translate}}</th>
                                <th>{{'DIFF_YEAR'| translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-subsidy>
                            <tr>
                                <td>{{subsidy.AppId}}</td>
                                <td>{{subsidy.Department}}</td>
                                <td>{{subsidy.Area | number : '1.2-2'}}</td>
                                <td>{{subsidy.SubsidyYear}}</td>
                                <td>{{subsidy.AadharNo}}</td>
                                <td>{{subsidy.System}}</td>
                                <td>{{subsidy.LandDetail}}</td>
                                <td>{{subsidy.DiffYear}}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="10">{{'NO_RECORDS_TO_SHOW'| translate}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>


            <div class="field">
                <label htmlFor="waterSourceType">{{'LAND_ID'| translate}} </label>
                <p-dropdown [options]="landIDList" formControlName="landId" optionLabel="displayName"
                    optionValue="LandID" placeholder="select  Land IDs"></p-dropdown>

            </div>

            <div class="field">
                <label htmlFor="waterSourceType">{{'MI'| translate}} </label>
                <p-dropdown [options]="miList" formControlName="mi" optionValue="Program_Id" optionLabel="Program_Name"
                    [(ngModel)]="selectedMI" placeholder="select a component" (onChange)="onSelectMI()">
                </p-dropdown>
            </div>
            <div class="field">
                <label htmlFor="waterSourceType">{{'VENDOR'| translate}} </label>
                <!-- <p-dropdown [options]="vendorList.Name" formControlName="vendor" optionLabel="Vendor_Code" optionValue="Vendor_Code" placeholder="select a vendor">
        </p-dropdown> -->
                <p-autoComplete placeholder="Vendor Search" id="dd" [dropdown]="true" [multiple]="false"
                    formControlName="vendor" [suggestions]="filteredmiVendorList"
                    (completeMethod)="filterMIVendor($event)" field="Name" (onSelect)="onVendorSelect($event)"
                    [(ngModel)]="miSelectedVendor"></p-autoComplete>

            </div>
        </form>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text" (click)="saveProduct()"></button>
    </ng-template>
</p-dialog>


<!-- dialog to add farmers in group -->
<p-dialog [(visible)]="addFarmerGroupDialog" [style]="{ width: '75%' }" header="Farmers Details" [modal]="true"
    styleClass="p-fluid">
    <p-table #dt [value]="farmerDetailsList" dataKey="Farmer_ID" responsiveLayout="scroll"
        [(selection)]="selectedFarmerLandDetails" [rows]="10" [paginator]="true" [globalFilterFields]="[
    'Name',
    'Father_name',
    'Mother_Name',
    'PPP_ID',
    'Aadhar_No',
    'Mobile',
    'Address'
  ]">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 1rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th style="width: 1rem"></th>
                <th pSortableColumn="Name">{{'NAME'| translate}} <p-sortIcon field="Name"></p-sortIcon>
                </th>
                <th pSortableColumn="Father_name">{{'FATHER_NAME'| translate}} <p-sortIcon field="Father_name"></p-sortIcon>
                </th>
                <th pSortableColumn="Mother_Name">{{'MOTHER_NAME'| translate}} <p-sortIcon field="Mother_Name"></p-sortIcon>
                </th>
                <th pSortableColumn="PPP_ID">{{'PPP_ID'| translate}} <p-sortIcon field="PPP_ID"></p-sortIcon>
                </th>
                <th pSortableColumn="Aadhar_No">{{'AADHAR'| translate}} <p-sortIcon field="Aadhar_No"></p-sortIcon>
                </th>
                <th pSortableColumn="Village_Code">{{'VILLAGE_CODE'| translate}} <p-sortIcon field="Village_Code"></p-sortIcon>
                </th>
                <th pSortableColumn="Mobile">{{'MOBILE'| translate}} <p-sortIcon field="Mobile"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-expanded="expanded">
            <tr>
                <td>
                    <p-tableCheckbox [value]="product"></p-tableCheckbox>
                </td>
                <td>
                    <button type="button" pButton pRipple [pRowToggler]="product"
                        class="p-button-text p-button-rounded p-button-plain"
                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </td>
                <td style="min-width: 12rem;">{{product.Name}}</td>
                <td style="min-width: 8rem;">{{product.Father_name}}</td>
                <td style="min-width: 10rem;">{{product.Mother_Name}}</td>
                <td style="min-width: 10rem;">{{product.PPP_ID}}</td>
                <td style="min-width: 8rem;">{{product.Aadhar_No}}</td>
                <td style="min-width: 10rem;">{{product.Village_Code}}</td>
                <td style="min-width: 10rem;">{{product.Mobile}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-product>
            <tr>
                <td colspan="7">
                    <div class="p-3">
                        <p-table [value]="product.landDetails" dataKey="Land_ID" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
            <tr>
                <th style="width: 1rem">
                    <p-tableHeaderCheckbox (click)="selectHeaderRow(headerRow.checked, product.landDetails)" #headerRow>
                    </p-tableHeaderCheckbox>
                </th>
                <th pSortableColumn="Land_ID">{{'LAND_ID'| translate}} <p-sortIcon field="Land_ID"></p-sortIcon>
                </th>
                <th pSortableColumn="Morabba_No">{{'MORABBA_NO'| translate}} <p-sortIcon field="Morabba_No"></p-sortIcon>
                </th>
                <th pSortableColumn="Killa_No">{{'KILLA_NO'| translate}} <p-sortIcon field="Killa_No"></p-sortIcon>
                </th>
                <th pSortableColumn="Kanals">{{'KANALS'| translate}} <p-sortIcon field="Kanals"></p-sortIcon>
                </th>
                <th pSortableColumn="Village_Code">{{'VILLAGE_CODE'| translate}} <p-sortIcon field="Village_Code"></p-sortIcon>
                </th>
                <th style="width: 4rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-order>
            <tr>
                <td>
                    <p-tableCheckbox [value]="order" (click)="selectRow(e.checked, order)" #e></p-tableCheckbox>
                </td>
                <td>{{order.Land_ID}}</td>
                <td>{{order.Morabba_No}}</td>
                <td>{{order.Killa_No}}</td>
                <td>{{order.Kanals}}</td>
                <td>{{order.Village_Code}}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6">{{'THERE_ARE_NO_LAND_FOR_THIS_FARMER'| translate}}.</td>
            </tr>
        </ng-template>
    </p-table>
    </div>
    </td>
    </tr>
    </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{'CANCEL'| translate}}" icon="pi pi-times" class="p-button-text"
            (click)="hideFarmersAddToGroupDialog()"></button>
        <button pButton pRipple label="{{'SAVE'| translate}}" icon="pi pi-check" class="p-button-text"
            (click)="saveFarmerToGroup()"></button>
    </ng-template>
</p-dialog>
<!-- edit-App-details-dialog-box-ends -->

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>